export default __webpack_public_path__ + "static/media/starter-pack-1-badge.9e9b1cb4.webp";